import {
  blue,
  lightBlue,
  blueGrey,
  grey,
  green,
  orange,
  red
} from '@material-ui/core/colors';
import { Palette } from '@material-ui/core/styles/createPalette';

const white = '#FFFFFF';

const palette: Partial<Palette> = {
  primary: {
    contrastText: white,
    dark: blue[900],
    main: blue[800],
    light: lightBlue[600]
  },
  secondary: {
    contrastText: white,
    dark: blueGrey[900],
    main: blueGrey[800],
    light: blueGrey[600]
  },
  success: {
    contrastText: white,
    dark: green[900],
    main: green[600],
    light: green[400]
  },
  info: {
    contrastText: white,
    dark: blue[900],
    main: blue[600],
    light: blue[400]
  },
  warning: {
    contrastText: white,
    dark: orange[900],
    main: orange[600],
    light: orange[400]
  },
  error: {
    contrastText: white,
    dark: red[900],
    main: red[600],
    light: red[400]
  },
  text: {
    primary: blueGrey[900],
    secondary: blueGrey[600],
    disabled: grey[700],
    hint: blueGrey[500]
    // link: blue[600]
  },
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: grey[200]
};

export default palette;
